export enum IconSize {
  S = 16,
  M = 24,
  L = 32,
  XL1 = 64,
  XL2 = 128,
  XL3 = 256,
  XL4 = 512,
}
